import { queryHooks } from '../../graphql';
import { currencyFromGraphQlCurrencyEnum, emptyCurrency } from '../../model/currency';

const useCurrency = () => {
    const { data, loading } = queryHooks.useGetCurrencyCodeQuery();
    return loading ? emptyCurrency : currencyFromGraphQlCurrencyEnum(data);
}

export default useCurrency;